import { CastingConnectionState } from "./CastingEvents";

/**
 * Null casting provider (default). Safe no-op until casting is enabled.
 */
export function createNullCastingProvider() {
  var state = CastingConnectionState.DISCONNECTED;

  return {
    name: "null-casting",
    getCapabilities: function () {
      return {
        id: "null",
        name: "None",
        discover: false,
        play: false,
        pause: false,
        seek: false,
        stop: false,
        volume: false,
        mute: false,
      };
    },
    initialize: function () {
      return Promise.resolve();
    },
    discoverDevices: function () {
      return Promise.resolve([]);
    },
    getDevices: function () {
      return [];
    },
    connect: function () {
      return Promise.reject(new Error("Casting not configured"));
    },
    disconnect: function () {
      state = CastingConnectionState.DISCONNECTED;
      return Promise.resolve();
    },
    loadMedia: function () {
      return Promise.resolve();
    },
    play: function () {
      return Promise.resolve();
    },
    pause: function () {
      return Promise.resolve();
    },
    seek: function () {
      return Promise.resolve();
    },
    stop: function () {
      return Promise.resolve();
    },
    setVolume: function () {
      return Promise.resolve();
    },
    setMuted: function () {
      return Promise.resolve();
    },
    synchronizeState: function () {
      return Promise.resolve();
    },
    getRemoteState: function () {
      return { target: "local", playing: false, currentTime: 0 };
    },
    getConnectionState: function () {
      return state;
    },
    isAvailable: function () {
      return false;
    },
    on: function () {
      return function () {};
    },
    off: function () {},
    destroy: function () {},
  };
}

export default createNullCastingProvider;
